import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/ai/_layout")({
  component: AILayout,
});

function AILayout() {
  return (
    <div className="h-full w-full">
      <Outlet />
    </div>
  );
}
